import { pharmacyClient } from "@/connect";
import { FastMovingItemsReportResponse } from "@/gen/reports/fast_moving_items_report_pb";

export const getFastMovingItems = async (
  page: number,
  pageSize: number
): Promise<FastMovingItemsReportResponse> => {
  return await pharmacyClient.fastMovingItemsReport({
    pageNumber: page,
    pageSize: pageSize,
  });
};